export const reproducibilityOptions = [
  { code: 'A', description: 'Not Applicable' },
  {
    code: 'B',
    description: 'Continuous',
  },
  {
    code: 'C',
    description: 'Intermittent',
  },
  {
    code: 'D',
    description: 'Fails After Warm Up',
  },
  {
    code: 'E',
    description: 'Environmental',
  },
  {
    code: 'F',
    description: 'Configuration: Peripheral',
  },
  {
    code: 'G',
    description: 'Damaged',
  },
  {
    code: 'H',
    description: 'Screening Request',
  },
]

export const pricingOptions:Array<string> = [
            'BAT',
            'DSPLY',
            'NOCHG'
          ]

export const coverageOptions:Array<string>=[
            'BATTERY',
            'OTHER',
            'DISPLAY',
            "APPLECARE_PLUS",
            'VMI_YELLOW',
            'DAMAGE_NOT_COVERED',
            'VMI_RED',
            'THEFTLOSS',
            'VMI_GREEN'
          ]

export const repairStatus:Array<string>=[
              "PCCU",
              "SPCM",
              "CRCP",
              "PWCB",
              "CFPH",
              "CRCN",
              "PCDS",
              "ASCH",
              "CUNR",
              "IFES",
              "AWTR",
              "COLU",
              "AWTP",
              "RLSD",
              "CCAR",
              "CRDE",
              "CCCR",
              "BEGR",
              "DELR",
              "CCNR",
              "RFPU"
            ]
